import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { ClientWindowSticker } from 'src/app/model/product/windowsticker/client-windowsticker';
import { isStandardStickerPart } from 'src/app/model/product/windowsticker/standard-sticker-part';
import {
  FoilChoices,
  LaminateChoices
} from 'src/app/model/product/windowsticker/windowsticker';
import { HeightWidthTuple } from 'src/app/model/util-classes/height-width-tuple';
import Material from '../../../../../model/material/material';

export class ClientWindowStickerFormHelper {
  private constructor() {}

  static readonly ALL_TEMPORARY_MATERIALS: WindowStickerMaterialsForFormat[] = [
    {
      label: 'Sticker (2 jaar)',
      material: FoilChoices.MONOMER
    },
    {
      label: FoilChoices.RAPID_AIR.name,
      material: FoilChoices.RAPID_AIR
    },
    {
      label: 'Transparante folie',
      material: FoilChoices.TRANSPARENT_FOIL_TEMPORARY
    },
    {
      label: FoilChoices.TRUE_VISION_TEMPORARY.name,
      material: FoilChoices.TRUE_VISION_TEMPORARY
    }
  ];

  static readonly ALL_PERMANENT_MATERIALS: WindowStickerMaterialsForFormat[] = [
    {
      label: FoilChoices.CAST_FOIL.name,
      material: FoilChoices.CAST_FOIL
    },
    {
      label: FoilChoices.ADHESIVE_LETTERS.name,
      material: FoilChoices.ADHESIVE_LETTERS
    },
    {
      label: 'Sticker (4/5 jaar)',
      material: FoilChoices.POLYMER
    },
    {
      label: FoilChoices.TRUE_VISION_PERMANENT.name,
      material: FoilChoices.TRUE_VISION_PERMANENT
    },
    {
      label: FoilChoices.TRANSPARENT_FOIL_PERMANENT.name,
      material: FoilChoices.TRANSPARENT_FOIL_PERMANENT
    },
    {
      label: FoilChoices.SANDBLAST_FOIL.name,
      material: FoilChoices.SANDBLAST_FOIL
    }
  ];

  static readonly ALL_TEMPORARY_LAMINATES: WindowStickerMaterialsForFormat[] = [
    {
      label: 'Blinkend',
      material: LaminateChoices.TEMPORARY_GLOSSY
    },
    {
      label: 'Mat',
      material: LaminateChoices.TEMPORARY_MATTE
    },
    {
      label: 'Geen',
      material: LaminateChoices.NO_LAMINATE
    }
  ];

  static readonly ALL_PERMANENT_LAMINATES: WindowStickerMaterialsForFormat[] = [
    {
      label: 'Blinkend',
      material: LaminateChoices.PERMANENT_GLOSSY
    },
    {
      label: 'Mat',
      material: LaminateChoices.PERMANENT_MATTE
    },
    {
      label: 'Geen',
      material: LaminateChoices.NO_LAMINATE
    }
  ];

  static getHeightTuplesForMaterialsRequest(
    windowSticker: ClientWindowSticker
  ): HeightWidthTuple[] {
    if (
      windowSticker == null ||
      !CollectionHelper.isPopulated(windowSticker.clientStickerParts)
    ) {
      return null;
    }

    const toReturn: HeightWidthTuple[] = [];
    windowSticker.clientStickerParts.forEach(p => {
      if (
        p != null &&
        p.instance != null &&
        isStandardStickerPart(p.instance) &&
        p.instance.selectedHeightWidth != null
      ) {
        toReturn.push(p.instance.selectedHeightWidth);
      }
    });
    CollectionHelper.uniqInPlaceBy(toReturn, JSON.stringify);
    return toReturn;
  }
}

export interface WindowStickerMaterialsForFormat {
  label: string;
  material: Material;
}
